import actions from "./actions";
import reducer from "./reducer";
import selectors from "./selectors";

const usersModule = { actions, selectors, reducer };

export default usersModule;
